import parse from 'html-react-parser'
import Link from 'next/link'
import router from 'next/router'
import { React, useState } from 'react'
import dynamic from 'next/dynamic'
import Header from '../components/header'
const Footer = dynamic(() => import('../components/footer'))
const MiniCart = dynamic(() => import('../components/cart/minicart'))
import Socialmedia from '../components/socialmedia';
import Scripts from '../components/scripts';
import MetaTags from '../components/MetaTags'

function ContactPage({ item, menu, config }) {

  const [form_submitted, set_form_submitted] = useState(false)


  const submit_and_validate_form = (event) => {
    event.preventDefault()
    var chk_status = event.target.checkValidity();
    event.target.reportValidity();
    if (chk_status) {
      var result = formsmailer_api_call(event)
    }
    if (result) {
      set_form_submitted(true)
    }
  }

  return (
    <>
      <MetaTags item={item} config={config}></MetaTags>
      <div className="wrapper h-full flex flex-col">
        <Header menu={menu} config={config}></Header>
        <section className="content flex flex-grow flex-col">

          <div className="hidden lg:block container mx-auto text-xs py-2 px-5 lg:px-0">
            <div className="space-x-2 flex items-center leading-none">
              <Link href="/">
                <a title="Home">
                  <i className="fas fa-home text-brand-tertiary"></i>
                </a>
              </Link>
              <span className="text-gray-400">/</span>
              <span className="text-gray-600">Contact Us</span>
            </div>
          </div>

          <div className="bg-gray-100 py-8 lg:py-16">
            <div className="container mx-auto lg:mb-4">
              <div className="flex justify-center">
                <div className="lg:w-8/12 lg:px-0 px-5">


                  {(form_submitted) ? (
                    <div className="lg:w-1/2 bg-white rounded-lg shadow p-5 lg:p-8 mx-auto text-center">
                      <div className="mb-2"><i className="fas fa-check-circle text-green-600 text-6xl"></i></div>
                      <h2 className="h2 mb-6">Message Sent</h2>
                      <p className="text-gray-900 mb-2">Your message has been sent. Someone will review your message and get back to you as soon as possible. </p>
                      <p className="text-gray-900 mb-4">Remember you can follow us on social media and stay up to date with all the latest news and offers!</p>
                      <a onClick={() => set_form_submitted(false)} className="btn btn-lg btn-primary mx-auto">Back to Contact Us</a>
                    </div>
                  ) : (
                    <>
                      {(item && item.description) ? (
                        parse(item.description)
                      ) : ('')}
                      <div className="lg:flex mt-8">
                        <div className="w-full lg:w-2/5 lg:mr-8 lg:px-0 px-5 mb-5 lg:mb-0">
                          <h3 className="mb-2">Get In Touch</h3>
                          <p className="text-gray-600 mb-4">Our online form is the easiest way to contact us, but you can also email, phone, DM or even write to us, using the details below.</p>
                          <ul className="space-y-2 mb-7">
                            <li>
                              <div className="flex mb-8">
                                <div className="w-1/12">
                                  <i className="text-gray-900 fas fa-home mr-1 text-base align-baseline"></i>
                                </div>
                                <div className="w-11/12">
                                  <span className="italic text-gray-600">
                                    {config.company_name}<br />
                                    {config.address}<br />
                                    {config.city}<br />
                                    {config.pcode}<br />
                                    Company No: {config.company_number}<br />
                                    VAT Number: {config.vat_number}.
                                  </span>
                                </div>
                              </div>
                            </li>
                            <li className="flex items-center">
                              <i className="text-gray-900 fas fa-phone-alt mr-1 fa-fw"></i>
                              <Link href={"tel:" + config.phone}>
                                <a className="text-brand-primary font-semibold underline hover:no-underline">
                                  {config.phone}
                                </a>
                              </Link>
                            </li>
                            <li className="flex items-center">
                              <i className="text-gray-900 fab fa-whatsapp mr-1 fa-fw"></i>
                              <Link href={"tel:" + config.whatsapp_phone}>
                                <a className="text-brand-primary font-semibold underline hover:no-underline">
                                  {config.whatsapp_phone}
                                </a>
                              </Link>
                            </li>
                            <li className="flex items-center">
                              <i className="text-gray-900 fas fa-at mr-1 fa-fw"></i>
                              <Link href={"mailto:" + config.email}>
                                <a className="text-brand-primary font-semibold underline hover:no-underline">
                                  {config.email}
                                </a>
                              </Link>
                            </li>
                          </ul>
                          <Socialmedia config={config}></Socialmedia>
                        </div>
                        <div className="w-full lg:w-3/5">
                          <form method="post" onSubmit={(event) => submit_and_validate_form(event)} className="bg-white rounded-lg shadow p-5 lg:p-8">
                            <p className="text-gray-600 text-base font-normal mb-3"><small>Fields marked with an asterix (<span className="text-red-600">*</span>) are required.</small></p>
                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">Your Name <span className="text-red-600">*</span></span>
                                <input type="" required name="name" placeholder="Enter your full name" className="input-field w-full" />
                              </label>
                            </div>
                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">Company Name</span>
                                <input type="" name="company" className="input-field w-full" placeholder="(optional)" />
                              </label>
                            </div>
                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">E-Mail Address <span className="text-red-600">*</span></span>
                                <input type="email" name="email" required placeholder="Where we will send responses to" className="input-field w-full" />
                              </label>
                            </div>
                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">Phone Number</span>
                                <input type="tel" name="phone" placeholder="Including area code" className="input-field w-full" />
                              </label>
                            </div>
                            {(router.query.part_number) ? (
                              <div className="mb-4">
                                <label className="field-label">
                                  <span className="label-text">Part Number</span>
                                  <input type="" value={router.query.part_number} name="part_number" className="input-field w-full" placeholder="(optional)" />
                                </label>
                              </div>
                            ) : ('')}
                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">Reason For Contact <span className="text-red-600">*</span></span>
                                <select name="reason_for_contact" required className="dropdown-field">
                                  <option>I have a question</option>
                                  <option>I need technical product assistance</option>
                                  <option>I can&apos;t find what I&apos;m looking for</option>
                                  <option>I need help using the website</option>
                                  <option>I need stock availability</option>
                                  <option>I would like a quotation</option>
                                  <option>I have a problem with my order</option>
                                  <option>I would like to cancel my order</option>
                                  <option>I would like to return a product</option>
                                  <option>Other</option>
                                </select>
                              </label>
                            </div>

                            <div className="mb-4">
                              <label className="field-label">
                                <span className="label-text">Message <span className="text-red-600">*</span></span>
                                <textarea name="query" required pleaceholder="Please provide as much detail as possible" cols="6" rows="6" className="input-field w-full"></textarea>
                              </label>
                            </div>
                            <button className="btn btn-primary btn-lg">Send Message</button>
                          </form>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>

        <Footer menu={menu} config={config}></Footer>
      </div>
      <MiniCart></MiniCart>
      <Scripts javascripts={item.javascripts}></Scripts>
    </>
  )
}


// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps(context) {
  const config_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/configs')
  const config_data = await config_res.json()
  const config = config_data.data

  const menu_res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/menu')
  const menu = await menu_res.json()

  const res = await fetch(process.env.NEXT_PUBLIC_API_URL + '/landingpage/contact')
  const response = await res.json()
  const page = response.data


  return {
    props: {
      config: config,
      menu: menu,
      item: page,
    },
    // Next.js will attempt to re-generate the page:
    // - When a request comes in
    // - At most once every 10 seconds
    revalidate: 600, // In seconds

  }
}


export default ContactPage

export const formsmailer_api_call = async (event) => {
  event.preventDefault()
  const data = new FormData(event.target);
  const form = Object.fromEntries(data.entries());

  const body_text = (form) => {
    var text = ""
    for (var key of Object.keys(form)) {
      text += ("<b>" + key + ":</b> " + form[key]) + "\n"
    }
    return text
  }

  // send the email as the email and the name at the remote end
  const res = fetch(
    process.env.NEXT_PUBLIC_API_URL + '/formsmailer',
    {
      body: JSON.stringify({
        body: body_text(form),
        subject: form.reason_for_contact,
        reply_to: form.email,
        device_name: 'browser'
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST'
    }
  )
    .then(response => {
      // reject not ok response
      if (!response.ok) {
        return Promise.reject(response)
      }
      return response.json() // or return response.text()
    })
    .catch(async response => {
      const error = await response.json().then(text => text)
      return Promise.reject(error)
    })
    .then(data => {
      return true
    })
    .catch((error) => {
      console.warn(error);
    });

}